var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFeatureSemiDetached(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1970",
    "data-name": "Group 1970",
    transform: "translate(185 -1034)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(-185 1034)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-151.59,1043.12l-1.578-1.579-.115-.115-7.3-7.3a.4.4,0,0,0-.573,0l-7.075,7.075-7.075-7.075a.4.4,0,0,0-.573,0l-7.3,7.3-.115.115-1.579,1.579a.4.4,0,0,0,0,.572.4.4,0,0,0,.573,0l.941-.941v10.469a.4.4,0,0,0,.409.409h4.907a.4.4,0,0,0,.409-.409v-6.952h4.089v6.952a.4.4,0,0,0,.409.409h9.815a.4.4,0,0,0,.409-.409v-6.952h4.089v6.952a.4.4,0,0,0,.409.409h4.907a.4.4,0,0,0,.409-.409v-10.469l.941.941a.384.384,0,0,0,.286.123.384.384,0,0,0,.286-.123A.4.4,0,0,0-151.59,1043.12Zm-17.053,9.692h-4.089v-6.952a.405.405,0,0,0-.409-.409h-4.907a.4.4,0,0,0-.409.409v6.952h-4.089v-10.878l6.952-6.944,6.788,6.78.164.164Zm14.722,0h-4.089v-6.952a.405.405,0,0,0-.409-.409h-4.907a.405.405,0,0,0-.409.409v6.952h-4.089v-10.878l.164-.164,6.788-6.78,6.952,6.944Z",
    transform: "translate(185 -1034)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_136",
    "data-name": "Path 136",
    d: "M-150.1,1042.154v10.878h-4.089v-6.952a.405.405,0,0,0-.409-.409H-159.5a.405.405,0,0,0-.409.409v6.952H-164v-10.878l.164-.164,6.788-6.78Z",
    transform: "translate(181.176 -1034.22)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M-168.1,1042.154v10.878h-4.089v-6.952a.405.405,0,0,0-.409-.409H-177.5a.405.405,0,0,0-.409.409v6.952H-182v-10.878l6.952-6.944,6.788,6.78Z",
    transform: "translate(184.454 -1034.22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureSemiDetached);
export default __webpack_public_path__ + "static/media/feature-semi-detached.5b41487fb520823e12655d3adeb46022.svg";
export { ForwardRef as ReactComponent };